import Mhd2Permissions from '@/constants/permissions';
import { selectUserPermissions } from '@/reducers/authReducer';
import { useAppSelector } from '@/store';
import React, { ComponentType } from 'react';

function withPermission<P extends object = {}>(
  requiredPermission: Mhd2Permissions | Mhd2Permissions[]
) {

  const permissionsArray = Array.isArray(requiredPermission)
    ? requiredPermission
    : [requiredPermission];

  return function (
    WrappedComponent: ComponentType<P>
  ): React.FC<P> {
    const ComponentWithPermission: React.FC<P> = (props) => {
      const userPermissions = useAppSelector(selectUserPermissions);

      const hasAllPermissions = permissionsArray.every((perm) =>
        userPermissions.includes(perm)
      );

      if (!hasAllPermissions) return null;

      return <WrappedComponent {...props} />;
    };

    return ComponentWithPermission;
  };
  // withPermission HOC: Returns the wrapped component only if the user has the required permission.
}

export default withPermission;